<template>
    <div class="Jsjb_file">
        <!--<div class="file_subTitle">-->
            <!--<div class="file_subTitle_left">-->
                <!--<span class="file_verticalLine"></span>-->
                <!--<p>工单信息</p>-->
            <!--</div>-->
            <!--<div class="file_subTitle_right">-->
                <!--<div class="file_subTitle_btn">-->
                    <!--<el-icon>-->
                        <!--<plus/>-->
                    <!--</el-icon>-->
                    <!--<span>批量下载</span>-->
                <!--</div>-->
            <!--</div>-->
        <!--</div>-->
        <div class="file_list">
            <el-table :data="tableData" style="width: 100%" @selection-change="handleSelectionChange">
                <el-table-column type="selection" width="55"/>
                <el-table-column prop="date" min-width="40%">
                    <template #default="scope">
                        <div style="display: flex; align-items: center">
                            <img class="fileIcon" src="../../../assets/images/ico_file_Group.png" alt="">
                            <span style="margin-left: 10px">{{ scope.row.date }}</span>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="name" min-width="10%"/>
                <el-table-column prop="name" min-width="25%"/>
                <el-table-column prop="address" min-width="25%" />
                <el-table-column align="center" width="100">
                    <template #default="scope">
                        <div style="display: flex; align-items: center;justify-content: center">
                            <i class="icon-eye_line"></i>
                            <i class="icon-download_2_line"></i>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
    </div>
</template>

<script>
    import {reactive, ref} from 'vue'

    export default {
        name: "File",
        setup() {
            const tableData = reactive([
                {
                    date: '2016-05-03',
                    name: 'Tom',
                    address: 'No. 189,',
                },
                {
                    date: '2016-05-02',
                    name: 'Tom',
                    address: 'No. 189, ',
                },
                {
                    date: '2016-05-04',
                    name: 'Tom',
                    address: 'No. 189, Gro',
                },
                {
                    date: '2016-05-01',
                    name: 'Tom',
                    address: 'No. 189, Grs',
                },
            ])
            return {
                tableData
            }
        }
    }
</script>

<style scoped>

</style>
